import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Package, Gift, ShoppingCart } from 'lucide-react';
import { UserContext } from '@/App';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart } = useContext(UserContext);
  const [animate, setAnimate] = useState(false);
  const [prevCount, setPrevCount] = useState(0);

  // Calculate total items in cart
  const cartItemCount = cart?.reduce((total, item) => total + (item.quantity || 1), 0) || 0;

  // Trigger animation when cart count increases
  useEffect(() => {
    if (cartItemCount > prevCount && cartItemCount > 0) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 300);
      return () => clearTimeout(timer);
    }
    setPrevCount(cartItemCount);
  }, [cartItemCount, prevCount]);

  const navItems = [
    { path: '/', icon: Home, label: 'Home', testId: 'nav-home' },
    { path: '/orders', icon: Package, label: 'Orders', testId: 'nav-orders' },
    { path: '/refer', icon: Gift, label: 'Refer & Earn', testId: 'nav-refer' },
    { path: '/cart', icon: ShoppingCart, label: 'Cart', testId: 'nav-cart' },
  ];

  return (
    <div className="bottom-nav">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-around">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            const isCart = item.path === '/cart';
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center gap-1 transition-colors ${
                  isActive ? 'text-green-600' : 'text-gray-600 hover:text-green-600'
                }`}
                data-testid={item.testId}
              >
                <div className="relative">
                  <Icon 
                    className={`w-6 h-6 transition-transform ${
                      isCart && animate ? 'scale-110' : ''
                    }`} 
                  />
                  {/* Cart Badge */}
                  {isCart && cartItemCount > 0 && (
                    <span 
                      className={`absolute -top-2 -right-2 min-w-[18px] h-[18px] bg-green-600 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1 transition-transform ${
                        animate ? 'scale-125' : 'scale-100'
                      }`}
                      data-testid="cart-badge"
                    >
                      {cartItemCount > 99 ? '99+' : cartItemCount}
                    </span>
                  )}
                </div>
                <span className="text-xs font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomNav;